"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryHasCashApp = exports.countryHasSepa = exports.countryHasAch = exports.countryHasPad = void 0;
const country_1 = require("../enums/country");
const countryHasPad = (country) => {
    return country === country_1.OrganizationCountry.Canada;
};
exports.countryHasPad = countryHasPad;
const countryHasAch = (country) => {
    return country === country_1.OrganizationCountry.UnitedStates;
};
exports.countryHasAch = countryHasAch;
const countryHasSepa = (country) => {
    return country === country_1.OrganizationCountry.Germany;
};
exports.countryHasSepa = countryHasSepa;
const countryHasCashApp = (country) => {
    return country === country_1.OrganizationCountry.UnitedStates;
};
exports.countryHasCashApp = countryHasCashApp;
